//【KYC 本人確認手続き】

    //【本人確認状況　ステータス】
    export const KYC_SETTINGS_UPLOAD        = 0   //本人確認写真のアップロードが必要です
    export const KYC_SETTINGS_CONFIRM       = 1   //本人確認写真を確認中です
    export const KYC_SETTINGS_APPROVAL      = 2   //承認済み
    export const KYC_SETTINGS_NON_APPROVAL  = 3   //非承認です。再度写真をアップロードしてください
    export const KYC_SETTINGS_RE_UPLOAD     = 4   //再アップロード済み
    export const KYC_SETTINGS_EMPTY         = 5   //空白

    //【旅券番号アスタリスク化】
    export const KYC_ASTERISK_NUM = 3  //アスタリスク化させる個数

    //【色】
    export const KYC_COLOR_PURPLE      = '#DFD0EA'  //紫
    export const KYC_COLOR_DARK_PURPLE = '#451493'  //濃紫
    export const KYC_COLOR_DEEP_PURPLE = '#350F71'  //深紫
    export const KYC_COLOR_GRAY        = '#c6c6c6'  //灰色
    export const KYC_COLOR_WHITE       = '#fff'     //白色

//【フォルシング設定状況】

    //【ボタン状態】
    export const STATUS_NOT_SET = 0 //未完了
    export const STATUS_ACTIVE  = 1 //完了
    export const STATUS_RENEWAL = 2 //次回契約受付中
    export const STATUS_HYPHEN  = 3 //ハイフン

//【フォルシング開始手続き】

    //【ステータス】
    export const HEC_DEFAULT       = '0.00000000' //HEC初期値

    //【色】
    export const HEC_COLOR_RED     = '#e3342f' //赤色

//【フォルシング開始手続き(申込)】

    // HecSaving機能使用定数
    export const HEC_SAVING_OFF_VALUE = 0
    export const HEC_SAVING_TWO_YEARS_VALUE = 2
    export const AUBE_COIN_STAKING_ONE_YEARS_VALUE = 1;
    export const AUBE_COIN_STAKING_TWO_YEARS_VALUE = 2;
    export const AUBE_COIN_STAKING_THREE_YEARS_VALUE = 3;
    export const AUBE_COIN_STAKING_FIVE_YEARS_VALUE = 5;

    export const FORTHING_CAMPAIGN_TERM_FIRST = "FIRST"
    export const FORTHING_CAMPAIGN_TERM_SECOND = "SECOND"

    export const MEMBERSHIP_FEE_TYPE_FORTHING_V3 = 'forthing_v3'

    //【会員区分】
    export const MEMBER_TYPE_ID_PROGRESS = 4000 // progress member
    export const MEMBER_TYPE_ID_PROGRESS_CHILD = 4001 // progress member

    export const MEMBER_TYPE_ID_ADVANCE = 1200 // advance member
    export const MEMBER_TYPE_ID_ADVANCE_CHILD = 1201 // advance child member

    export const TYPE_KYC_PASSPORT = 0;
    export const TYPE_KYC_DRIVER_LICENSE = 1;
    export const TYPE_KYC_ID_CARD = 2

    export const THEME_COLOR_HEADER_BY_ROUTE = {
        MOBILE_WHITE_COLOR: [
            'home',
            'video',
            'faq',
            'news',
            'terms',
            'policy',
            'tokushoho',
            'operating',
            'contact',
            'guide',
            'bonusTerms'
        ],

        DESKTOP_WHITE_COLOR: [
            'home',
        ],
    }